// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mm-0";